import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import {
  ActivatedRoute,
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from "@angular/router";
import { filter, takeUntil, distinctUntilChanged } from "rxjs/operators";
import { Subject, Subscription, asyncScheduler } from "rxjs";
import { observeOn } from "rxjs/operators";
import { AuthService } from "./auth/auth.service";
import { isPlatformBrowser } from "@angular/common";
import { SidenavService } from "./services/sidenav.service";
import { MatSidenav } from "@angular/material/sidenav";
// import { LoadingService } from "./services/loading.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("sidenavNav") public sidenavNav: MatSidenav;

  activeLang: string = "EN";
  cookiesAcp: string = "accepted";

  // NOTE: pipe to next tick so template doesn't see flips in the same CD pass
  // loadingView$ = this.loading.loading$.pipe(
  //   distinctUntilChanged(),
  //   observeOn(asyncScheduler) // effectively delay(0) without importing delay
  // );

  private unsubscribe$ = new Subject<void>();
  private subs = new Subscription();

  constructor(
    private _translocoService: TranslocoService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private sidenavService: SidenavService,
    // private loading: LoadingService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Cookies
    this.cookiesAcp = localStorage.getItem("cookies") || "accepted";

    // Language on NavigationEnd
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(() => {
        const lang = this.route.snapshot.firstChild?.paramMap.get("lang");
        if (lang && lang !== "EN") {
          this._translocoService.setActiveLang(lang);
          this.activeLang = lang;
        }
      });
  }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    this.sidenavService.setSidenav(this.sidenavNav);

    // Subscribe router events AFTER first render to avoid NG0100
    // this.subs.add(
    //   this.router.events
    //     .pipe(
    //       filter(
    //         (e) =>
    //           e instanceof NavigationStart ||
    //           e instanceof NavigationEnd ||
    //           e instanceof NavigationCancel ||
    //           e instanceof NavigationError
    //       )
    //     )
    //     .subscribe((e) => {
    //       if (e instanceof NavigationStart) this.loading.start();
    //       else this.loading.stop();
    //     })
    // );

    const token = localStorage.getItem("accessToken");
    if (token) {
      this.authService.check().pipe(takeUntil(this.unsubscribe$)).subscribe();
    }
  }

  acceptFun() {
    localStorage.setItem("cookies", "accepted");
    this.cookiesAcp = "accepted";
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.subs.unsubscribe();
  }
}
